import React, { useEffect } from 'react';
import AvailablePlans from 'features/subscription/components/AvailablePlans';
import { useSubscription } from 'features/user/hooks/useSubscription';
import { MyPlanDetails } from 'features/subscription/components/MyPlanDetails';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useUser from 'features/user/hooks/useUser';
import { appRoutes } from 'features/app/routes/paths';
import { RegistrationRequestStatusType } from 'features/auth/ts';

export const PlanView: React.FC = () => {
  const { subscription } = useSubscription();
  const [subscriptionButtonDisabled, setSubscriptionButtonDisabled] = React.useState<boolean>(false);
  const { user } = useUser();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch({ type: 'GET_PLANS_DETAILS' });
  }, [dispatch]);

  useEffect(() => {
    const userRoles = user?.roles.map(role => role.name);
    if (
      (userRoles && !userRoles.includes('super_admin')) ||
      user?.registration_request_status !== RegistrationRequestStatusType.APPROVED
    )
      history.replace(appRoutes.static.root);
  }, [history, user?.roles, user?.registration_request_status]);

  return !subscription ? (
    <AvailablePlans
      subscriptionButtonDisabled={subscriptionButtonDisabled}
      setSubscriptionButtonDisabled={setSubscriptionButtonDisabled}
    />
  ) : (
    <MyPlanDetails
      subscriptionButtonDisabled={subscriptionButtonDisabled}
      setSubscriptionButtonDisabled={setSubscriptionButtonDisabled}
    />
  );
};
